/**
 *
 * @param $scope
 * @param $state
 * @param messagesResolve
 * @constructor
 */
var MessageBoxCtrl = function($scope, $state, messagesResolve) {
  this.$scope = $scope;
  this.$state = $state;
  this.messagesResolve = messagesResolve;

  $scope.limit = 10;
  $scope.messages = messagesResolve;
};

/**
 * open message with specific id
 * @param message
 */
MessageBoxCtrl.prototype.openMessage = function(message) {
  var allowedTypes = {
    mail: true,
    sms: true,
  };

  if (message.type && allowedTypes[message.type]) {
    this.$state.go('private.main.message.' + message.type, { messageId: message._id });
  }
};

module.exports = MessageBoxCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/message/MessageBoxCtrl.js